import { combineReducers } from 'redux';

import * as c from '../constants';


const EDIT_INIT_STATE = {
  isModalActive: false,
  mode: c.HOTKEY_TMP_EDIT_TAB,
  hotkey: {}
}


function editModalReducer(state = EDIT_INIT_STATE, action) {
  switch (action.type) {
    case c.HOTKEY_TMP_RESET: {
      return EDIT_INIT_STATE;
    }

    case c.HOTKEY_TMP_RESET_EDIT_MODAL: {
      return EDIT_INIT_STATE;
    }

    case c.HOTKEY_TMP_EDIT_HOTKEY: {
      const { mode, payload: hotkey } = action;
      return {
        ...state,
        mode,
        hotkey,
        isModalActive: true
      }
    }
        
    default: {
      return state;
    }
  }
}


const ADD_INIT_STATE = {
  isModalActive: false,
  mode: c.MODAL_MODE_ADD_TAB
}


function addModalReducer(state = ADD_INIT_STATE, action) {
  switch (action.type) {
    case c.HOTKEY_TMP_RESET: {
      return ADD_INIT_STATE;
    }

    case c.HOTKEY_TMP_RESET_ADD_MODAL: {
      return ADD_INIT_STATE;
    }

    case c.HOTKEY_TMP_SHOW_ADD_MODAL: {
      return {
        ...state,
        isModalActive: true,
        mode: action.payload
      }
    }

    default: {
      return state;
    }
  }
}


const modalReducer = combineReducers({
  edit: editModalReducer,
  add: addModalReducer
});


export default modalReducer;
